import { COLORS } from './constants.js';

export function findNodeAtEvent(canvas, nodes, event) {
  const rect = canvas.getBoundingClientRect();
  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;

  return nodes.find(node => (
    x >= node.left &&
    x <= node.left + node.width &&
    y >= node.top &&
    y <= node.top + node.height
  ));
}

export function updateOverlay({ canvas, overlay, overlayPhase, overlayTitle, overlayDescription, event, node }) {
  if (!overlay) return;

  if (!node) {
    hideOverlay(overlay);
    return;
  }

  if (overlayPhase) {
    overlayPhase.textContent = node.phase || 'Phase';
    overlayPhase.style.color = node.color || COLORS.brand500;
  }
  if (overlayTitle) overlayTitle.textContent = node.label;
  if (overlayDescription) overlayDescription.textContent = node.description || '';

  overlay.classList.remove('hidden');

  const rect = canvas.getBoundingClientRect();
  const overlayWidth = overlay.offsetWidth || 260;
  const overlayHeight = overlay.offsetHeight || 132;
  const maxLeft = Math.max(rect.width - overlayWidth - 12, 12);
  const maxTop = Math.max(rect.height - overlayHeight - 12, 12);
  const left = Math.min(Math.max(event.clientX - rect.left + 20, 12), maxLeft);
  const top = Math.min(Math.max(event.clientY - rect.top + 20, 12), maxTop);

  overlay.style.left = `${left}px`;
  overlay.style.top = `${top}px`;
}

export function hideOverlay(overlay) {
  if (!overlay) return;

  overlay.classList.add('hidden');
}

export function parseDiagramData(canvas) {
  const raw = canvas.dataset.publicDiagramData;
  if (!raw) return {};

  try {
    return JSON.parse(raw);
  } catch (_error) {
    return {};
  }
}
